import { setGeo } from './helpers';
import { type TJsonQuery } from './types';

export function clearGeo(jsonQuery: TJsonQuery): () => TJsonQuery {
  return () => setGeo()(jsonQuery)([]);
}
